import React from 'react';
import { motion } from 'framer-motion';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';

// Sample avatar data - these will show stacked avatars
const avatarData = [
  { initials: 'JM', color: 'bg-emerald-500' },
  { initials: 'SK', color: 'bg-amber-500' },
  { initials: 'TN', color: 'bg-blue-500' },
  { initials: 'LP', color: 'bg-purple-500' },
  { initials: 'AM', color: 'bg-rose-500' },
];

const SocialProofSection = ({ count = '5k+' }) => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center justify-center gap-4"
        >
          {/* Stacked Avatars */}
          <div className="flex items-center">
            <div className="flex -space-x-3">
              {avatarData.map((avatar, index) => (
                <Avatar
                  key={index}
                  className={`h-10 w-10 border-2 border-white ring-0 ${avatar.color}`}
                  style={{ zIndex: avatarData.length - index }}
                >
                  <AvatarFallback className={`${avatar.color} text-white text-xs font-medium`}>
                    {avatar.initials}
                  </AvatarFallback>
                </Avatar>
              ))}
              
              {/* Count badge */}
              <div
                className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-white text-xs font-semibold"
                style={{ 
                  background: 'var(--accent-primary)',
                  color: 'var(--text-primary)',
                  zIndex: 0 
                }}
              >
                +{count}
              </div>
            </div>
          </div>

          {/* Text */}
          <p className="text-center" style={{ color: 'var(--text-secondary)' }}>
            <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>{count}</span>
            {' '}people have joined the waitlist
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofSection;
